import axios from 'axios';

const GetAllUsers = () => {
	const token = localStorage.getItem('token');
	return axios.get('https://backend.planmyleisure.com/user/all_infor', {
		headers: { Authorization: token },
	});
};
export default GetAllUsers;
